export default [
    'SDG_Guidelines_AUччG_2019_Final 1',
    'accordions/folder-simple',
    'accordions/folders',
    'accordions/minus-circle',
    'accordions/minus',
    'accordions/plus-circle',
    'accordions/plus',
    'arrows/arrow-triangle',
    'arrows/caret-double',
    'arrows/caret-light',
    'arrows/caret',
    'arrows/long-arrow-small',
    'arrows/long-arrow',
    'arrows/round-arrow-big',
    'arrows/round-arrow-small',
    'bioreactor',
    'cabinet/sign_in',
    'cabinet/sign_out',
    'cabinet/user_circle',
    'calendar/calendar-1',
    'calendar/calendar-31',
    'calendar/calendar-add',
    'calendar/calendar-x',
    'calendar/calendar',
    'calendar/google',
    'calendar/ical',
    'calendar/outlook',
    'calendar/yahoo',
    'committee/chairman-en',
    'committee/chairman-ru',
    'committee/member-en',
    'committee/member-ru',
    'contacts/at',
    'contacts/desktop',
    'contacts/email',
    'contacts/email_mini',
    'contacts/fax',
    'contacts/map',
    'contacts/mappin',
    'contacts/phone',
    'contacts/phone_mini',
    'contacts/phonein',
    'contacts/user',
    'file/big/audio',
    'file/big/csv',
    'file/big/datafile',
    'file/big/doc',
    'file/big/docx',
    'file/big/gif',
    'file/big/jpeg',
    'file/big/jpg',
    'file/big/mp3',
    'file/big/mp4',
    'file/big/no-file',
    'file/big/odt',
    'file/big/pdf',
    'file/big/png',
    'file/big/ppt',
    'file/big/presentation',
    'file/big/press-release',
    'file/big/rar',
    'file/big/report',
    'file/big/rtf',
    'file/big/tif',
    'file/big/tiff',
    'file/big/txt',
    'file/big/webm',
    'file/big/xls',
    'file/big/xlsx',
    'file/big/zip',
    'file/small/csv',
    'file/small/doc',
    'file/small/docx',
    'file/small/gif',
    'file/small/jpeg',
    'file/small/jpg',
    'file/small/mp3',
    'file/small/mp4',
    'file/small/no-file',
    'file/small/odt',
    'file/small/pdf',
    'file/small/png',
    'file/small/ppt',
    'file/small/rar',
    'file/small/rtf',
    'file/small/tif',
    'file/small/tiff',
    'file/small/txt',
    'file/small/webm',
    'file/small/xls',
    'file/small/xlsx',
    'file/small/zip',
    'form/l/arrow',
    'form/l/calendar',
    'form/l/check',
    'form/l/close',
    'form/l/dot',
    'form/l/dragndrop',
    'form/l/magnifier',
    'form/l/paperclip',
    'form/m/arrow',
    'form/m/calendar',
    'form/m/check',
    'form/m/close',
    'form/m/dot',
    'form/m/dragndrop',
    'form/m/magnifier',
    'form/m/paperclip',
    'form/m/qwestion-hover',
    'form/m/tooltip-hover',
    'form/m/warning',
    'form/s/arrow',
    'form/s/calendar',
    'form/s/check',
    'form/s/close',
    'form/s/dot',
    'form/s/magnifier',
    'general/attention',
    'general/check',
    'general/checkmark',
    'general/info',
    'general/multipoint',
    'general/spinner',
    'general/warning',
    'icon/BuildingOffice',
    'icon/banknotes',
    'icon/factory',
    'icon/fire',
    'icon/handshake',
    'icon/heart',
    'icon/jun',
    'icon/leader',
    'icon/map-pin',
    'icon/medicine',
    'icon/pin-2',
    'icon/school',
    'icon/sovet',
    'icon/sport',
    'icon/student',
    'icon/support-2',
    'icon/support',
    'icon/tradici',
    'icon/umbrella',
    'icon/voulanteer',
    'icon-oon/1-cn',
    'icon-oon/10-cn',
    'icon-oon/11-cn',
    'icon-oon/11-en',
    'icon-oon/11',
    'icon-oon/12-cn',
    'icon-oon/12-en',
    'icon-oon/12',
    'icon-oon/13-cn',
    'icon-oon/13-en',
    'icon-oon/13',
    'icon-oon/14-cn',
    'icon-oon/15-cn',
    'icon-oon/15-en',
    'icon-oon/16-cn',
    'icon-oon/17-cn',
    'icon-oon/2-cn',
    'icon-oon/3-cn',
    'icon-oon/3-en',
    'icon-oon/3',
    'icon-oon/4-cn',
    'icon-oon/5-cn',
    'icon-oon/6-cn',
    'icon-oon/7-cn',
    'icon-oon/7-en',
    'icon-oon/7',
    'icon-oon/8-cn',
    'icon-oon/8-en',
    'icon-oon/8',
    'icon-oon/9-cn',
    'icon-oon/9-en',
    'icon-oon/9',
    'icon-oon/logo-m-cn',
    'icon-oon/logo-s-cn',
    'icon-oon/type8',
    'link/breadcrumbs-1',
    'link/breadcrumbs',
    'link/external-mini',
    'link/external',
    'link/home',
    'link/internal',
    'list/checkmark-big',
    'list/checkmark',
    'list/dash-big',
    'list/dash',
    'list/delimiter-big',
    'list/delimiter',
    'list/dot-big',
    'list/dot',
    'list/square-big',
    'list/square',
    'list/star',
    'media/audio-1',
    'media/audio',
    'media/datafile',
    'media/documents',
    'media/photo',
    'media/presentation',
    'media/press-release',
    'media/report',
    'media/site',
    'media/video',
    'project/1',
    'project/10',
    'project/103',
    'project/104',
    'project/105',
    'project/106',
    'project/107',
    'project/108',
    'project/109',
    'project/110',
    'project/111',
    'project/112',
    'project/113',
    'project/114',
    'project/115',
    'project/116',
    'project/117',
    'project/118',
    'project/119',
    'project/12',
    'project/120',
    'project/121',
    'project/122',
    'project/123',
    'project/124',
    'project/125',
    'project/126',
    'project/127',
    'project/128',
    'project/129',
    'project/13',
    'project/130',
    'project/131',
    'project/132',
    'project/133',
    'project/134',
    'project/135',
    'project/136-duplicate-name',
    'project/136',
    'project/137',
    'project/138',
    'project/139',
    'project/14',
    'project/140',
    'project/141',
    'project/142',
    'project/143',
    'project/15',
    'project/16',
    'project/17',
    'project/18',
    'project/19',
    'project/2',
    'project/20',
    'project/21',
    'project/22',
    'project/23',
    'project/24',
    'project/25',
    'project/26',
    'project/27',
    'project/28',
    'project/29',
    'project/3',
    'project/30',
    'project/31',
    'project/32',
    'project/33',
    'project/34',
    'project/35',
    'project/36',
    'project/37',
    'project/38',
    'project/39',
    'project/4',
    'project/40',
    'project/41',
    'project/42',
    'project/43',
    'project/44',
    'project/45',
    'project/46',
    'project/47',
    'project/48',
    'project/49',
    'project/5',
    'project/50',
    'project/51',
    'project/52',
    'project/53',
    'project/54',
    'project/55',
    'project/56',
    'project/57',
    'project/58',
    'project/6',
    'project/60',
    'project/61',
    'project/62',
    'project/63',
    'project/64',
    'project/65',
    'project/66',
    'project/7',
    'project/70',
    'project/71',
    'project/72',
    'project/73',
    'project/74',
    'project/75',
    'project/76',
    'project/77',
    'project/78',
    'project/79',
    'project/8',
    'project/80',
    'project/81',
    'project/82',
    'project/83',
    'project/84',
    'project/85',
    'project/86',
    'project/87',
    'project/88',
    'project/89',
    'project/9',
    'project/90',
    'project/91',
    'project/92',
    'project/93',
    'project/94',
    'project/95',
    'project/96',
    'project/97',
    'project/98',
    'project/arrow',
    'social/facebook-2',
    'social/facebook',
    'social/instagram',
    'social/linkedin',
    'social/max',
    'social/ok',
    'social/rutube',
    'social/share',
    'social/shoppers',
    'social/telegram',
    'social/tinkoff-pulse',
    'social/twitter-2',
    'social/twitter',
    'social/vk',
    'social/whatsapp',
    'social/wifi',
    'social/yandex_zen',
    'social/youtube',
    'storm-drainage',
    'tools/Asterisk',
    'tools/Document Add',
    'tools/Flag 2',
    'tools/Medal Ribbon',
    'tools/Sun 2',
    'tools/archive',
    'tools/archive_box',
    'tools/audio',
    'tools/burger',
    'tools/calculator',
    'tools/cast',
    'tools/certificate',
    'tools/close-small',
    'tools/close',
    'tools/cookie',
    'tools/copy',
    'tools/dots-vertical',
    'tools/download-1',
    'tools/filtering',
    'tools/gear',
    'tools/gistogram',
    'tools/graphic',
    'tools/lock',
    'tools/magnifier-minus',
    'tools/magnifier-plus',
    'tools/magnifier',
    'tools/pause-circle',
    'tools/pause_l',
    'tools/pause_m',
    'tools/play_l',
    'tools/play_m',
    'tools/play_s',
    'tools/presentation',
    'tools/press-release',
    'tools/printer',
    'tools/quotation',
    'tools/qwestion-hover',
    'tools/qwestion',
    'tools/refresh-double',
    'tools/refresh',
    'tools/report',
    'tools/shield-check',
    'tools/tag',
    'tools/tooltip-hover',
    'tools/tooltip',
    'tools/tooltip2-hover',
    'tools/tooltip2',
    'tools/trophy',
    'tools/unlock',
    'tools/warning',
    'wastewater-plants',
    'water-circulation',
    'water-tank',
    'wireframe/page',
    'wireframe/site'
]
